import { AxiosResponse } from "axios";
import AxiosService from "./Axios"
import BaseApi from "./BaseApi";

const BASE_URL = "/alarm-rule";

class AlarmRuleApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async getAllAlarmRuleViews(): Promise<AxiosResponse<any>> {
        return AxiosService.get('/alarm-rule/view/all');
    }
}

export default AlarmRuleApi;
